/**
 * Marquesina Data Handler
 * Paso 3: Cargar datos del metaobjeto y buscar coincidencia
 */

(function() {
  'use strict';

  // Configuración
  const METAOBJECT_TYPE = 'influencer_data';
  const URL_PARAM = 'dto';

  class MarquesinaData {
    constructor() {
      this.dtoValue = null;
      this.influencer = null; // Datos del influencer que coincida
      this.allData = null;    // Todos los datos del metaobjeto
      this.debugMode = false; // ← nuevo
      
      this.init();
    }

    init() {
      console.log('[Marquesina] Iniciando...');
      
      // 1. Extraer parámetro dto de la URL
      this.dtoValue = this.extractDtoParam();
      
      if (!this.dtoValue) {
        console.log('[Marquesina] No hay parámetro dto en la URL');
        return;
      }
      
      console.log('[Marquesina] Identificador encontrado:', this.dtoValue);
      
      // 2. Cargar datos del metaobjeto
      this.loadMetaobjectData();
      
      // 3. Buscar coincidencia
      this.findMatch();
    }

    extractDtoParam() {
      const urlParams = new URLSearchParams(window.location.search);
      const dto = urlParams.get(URL_PARAM);
      this.debugMode = urlParams.has('preview-tarjeta');
      return dto ? dto.trim() : null;
    }

    loadMetaobjectData() {
      const dataElement = document.querySelector('#marquesina-data');
      
      if (!dataElement) {
        console.log('[Marquesina] ❌ No se encontró el elemento de datos');
        return;
      }

      try {
        const rawData = dataElement.dataset.metaobjects;
        this.allData = JSON.parse(rawData);
        console.log('[Marquesina] ✅ Datos cargados:', this.allData.length, 'registros');
      } catch (e) {
        console.log('[Marquesina] ❌ Error al parsear datos:', e);
      }
    }

    findMatch() {
      if (!this.allData || !this.dtoValue) {
        return;
      }

      const dtoLower = this.dtoValue.toLowerCase();
  
      this.influencer = this.allData.find(entry => {
        const descuentoId = entry.descuento_id || '';
        return descuentoId.toLowerCase() === dtoLower;
      });

      if (this.influencer) {
        console.log('[Marquesina] ✅ Influencer encontrado:', this.influencer);
    
        // Disparar evento para que marquesina.liquid lo escuche
        document.dispatchEvent(new CustomEvent('marquesina-data-ready', {
          detail: {
            influencer: this.influencer,
            debugMode: this.debugMode
            }
        }));
    
      } else {
        console.log('[Marquesina] ❌ No se encontró coincidencia para:', this.dtoValue);
      }
    }

    

    // Método público para acceder a los datos
    getData() {
      return {
        dto: this.dtoValue,
        influencer: this.influencer,
        allData: this.allData
      };
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.marquesinaData = new MarquesinaData();
    });
  } else {
    window.marquesinaData = new MarquesinaData();
  }

})();
